import styled from 'styled-components';

export default styled.div`
  display: none;
  position: absolute;
  top: 18%;
  left: -20%;
  
  &.visible {
    display: block;
  }
`;
